import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ca44358")

_pushScopeId("data-v-8ca44358")
const _hoisted_1 = { class: "privacy__container uk-flex uk-flex-center" }
const _hoisted_2 = { class: "privacy__content body-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "privacy__title display-2" }, "Privacy Policy", -1)
const _hoisted_4 = { class: "last-updated heading-6" }
const _hoisted_5 = { class: "privacy__section" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "privacy__subtitle heading-3" }, "Introduction", -1)
const _hoisted_7 = { class: "privacy__section" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "privacy__subtitle heading-3" }, "Definitions", -1)
const _hoisted_9 = { class: "privacy__term" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "privacy__section" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_NavBar, { "logged-in": _ctx.isLoggedIn }, null, 8, ["logged-in"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, "Last updated: " + _toDisplayString(_ctx.dateOfUpdate), 1),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.introduction, (sent, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              innerHTML: sent,
              class: "privacy__text"
            }, null, 8, ["innerHTML"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.definitions, (def, index) => {
            return (_openBlock(), _createBlock("div", {
              key: def.term
            }, [
              _createVNode("span", _hoisted_9, _toDisplayString(def.term + " "), 1),
              _createVNode("span", {
                innerHTML: def.definition
              }, null, 8, ["innerHTML"]),
              (index != Object.keys(_ctx.definitions).length - 1)
                ? (_openBlock(), _createBlock("br", _hoisted_10))
                : _createCommentVNode("", true),
              (index != Object.keys(_ctx.definitions).length - 1)
                ? (_openBlock(), _createBlock("br", _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.content, (section) => {
          return (_openBlock(), _createBlock("div", {
            key: section.title
          }, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", {
                id: section.title === 'Use of Cookies' ? 'cookies' : '',
                class: " privacy__subtitle heading-3"
              }, _toDisplayString(section.title), 9, ["id"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(section.texts, (text, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "privacy__text",
                  key: index,
                  innerHTML: text
                }, null, 8, ["innerHTML"]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
})